import { Button, PopUp, PopUpProps, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    maxWidth: 600,
  },
  text: {
    marginTop: Spacing.L,
    marginBottom: Spacing.L,
  },
  bottom: {
    marginTop: Spacing.L,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: -Spacing.XS,
  },
  button: {
    marginHorizontal: Spacing.XS,
  },
})

interface Props extends PopUpProps {
  onRevoke?: (email?: string) => void
}
const RevokeConfirm = (props: Props) => {
  const { style, onClose, onRevoke, ...otherProps } = props
  const { t } = useTranslation()

  return (
    <PopUp onClose={onClose} style={[styles.container, style]} {...otherProps}>
      <Text level={2}>
        <Trans>Remove user from company</Trans>
      </Text>
      <Text style={styles.text}>
        <Trans>
          You are about to remove the user from this specific company. The user will maintain their access to different
          companies if applicable. If the user added or adjusted any schedules or zones, their icon will be changed to
          'unknown user' and can thus not be traced back to this user. This action cannot be undone.
        </Trans>
      </Text>
      <View style={styles.bottom}>
        <Button
          left="trash"
          title={t('Remove user from company')}
          size="L"
          danger
          onPress={() => onRevoke?.()}
          testID="RevokeConfirm.Confirm"
          style={styles.button}
        />
        <Button title={t('Cancel')} size="L" onPress={onClose} testID="RevokeConfirm.Cancel" style={styles.button} />
      </View>
    </PopUp>
  )
}

export default RevokeConfirm
